import { render, staticRenderFns } from "./hue.vue?vue&type=template&id=3a59b119"
import script from "./hue.vue?vue&type=script&lang=js"
export * from "./hue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports